import React from "react";
import "../styles/print.stye.css";

const SignaturePrint = ({
  title,
  prefix,
  position,
  isDate,
  isPosition,
  data,
}: {
  title: string;
  prefix: string;
  position: string;
  isDate: boolean;
  isPosition: boolean;
  data: any;
}) => {
  const generateEllipsisLine = (minLength: number) => {
    return ".".repeat(minLength);
  };
  return (
    <>
      <div className="w-full flex justify-center items-center space-content">
        <span className="">{title}</span>
      </div>
      <div className="w-full flex justify-center items-center space-content">
        <span className="">{prefix}</span>
        <span className="ellipsis-container">
          <span className="ellipsis-data">{null}</span>
          <span className="ellipsis-dots">{generateEllipsisLine(75)}</span>
        </span>
        <span className="">{position}</span>
      </div>
      {isPosition ? (
        <div className="w-full flex justify-center items-center space-content">
          <span className="">ตำแหน่ง</span>
          <span className="ellipsis-container">
            <span className="ellipsis-data">{null}</span>
            <span className="ellipsis-dots">
              {generateEllipsisLine(position ? 100 : 75)}
            </span>
          </span>
        </div>
      ) : (
        <div className="w-full flex justify-center items-center space-content">
          <span className="">(</span>
          <span className="ellipsis-container">
            <span className="ellipsis-data">{null}</span>
            <span className="ellipsis-dots">
              {generateEllipsisLine(position ? 100 : 75)}
            </span>
          </span>
          <span className="">)</span>
        </div>
      )}
      {isDate ? (
        <>
          <div className="w-full flex justify-center items-center space-content">
            <span className="ellipsis-container">
              <span className="ellipsis-data">{null}</span>
              <span className="ellipsis-dots">{generateEllipsisLine(30)}</span>
            </span>
            <span className="">/</span>
            <span className="ellipsis-container">
              <span className="ellipsis-data">{null}</span>
              <span className="ellipsis-dots">{generateEllipsisLine(30)}</span>
            </span>
            <span className="">/</span>
            <span className="ellipsis-container">
              <span className="ellipsis-data">{null}</span>
              <span className="ellipsis-dots">{generateEllipsisLine(30)}</span>
            </span>
          </div>
        </>
      ) : null}
    </>
  );
};

export default SignaturePrint;
